<!--
 * @Descripttion: 首页组件
 * @Author: congz
 * @Date: 2020-06-04 11:22:40
 * @LastEditors: congz
 * @LastEditTime: 2020-08-12 21:20:08
--> 

<template>
  <div class="home" id="home" name="home">
    <!-- Hero Section -->
    <div class="hero">
      <div class="hero-banner" :style="{ backgroundImage: `url(${currentHeroImage})` }">
        <div class="hero-overlay">
          <div class="hero-title">Style that Fits Every Occasion</div>
          <div class="hero-desc">
            Discover tailored suits, crisp shirts, blazers and casual wear crafted for the modern Indian man. Sharp silhouettes, premium fabrics — confidence you wear.
          </div>
          <router-link class="hero-btn" to="/goods">Shop Now</router-link>
        </div>
        <div class="hero-dots">
          <span
            v-for="(img, idx) in heroImages"
            :key="idx"
            class="hero-dot"
            :class="{ active: heroIndex === idx }"
            @click="setHeroIndex(idx)"
          ></span>
        </div>
      </div>
    </div>

    <!-- Category Products Section -->
    <div class="main-box">
      <div class="main">
        <div class="section-header">
          <h2>New Arrivals</h2>
          <p>Fresh men's styles just landed</p>
        </div>
        <div class="category-products">
          <ProductGrid :list="homeProducts" :isMore="false"></ProductGrid>
        </div>

        <!-- Why Shop With Us -->
        <div class="why-section">
          <div class="why-item">
            <div class="why-icon">🚚</div>
            <h3>Free Shipping</h3>
            <p>On orders above ₹499</p>
          </div>
          <div class="why-item">
            <div class="why-icon">👔</div>
            <h3>Premium Quality</h3>
            <p>Curated fabrics &amp; fine craftsmanship</p>
          </div>
          <div class="why-item">
            <div class="why-icon">🔄</div>
            <h3>Easy Returns</h3>
            <p>7-day hassle-free returns</p>
          </div>
          <div class="why-item">
            <div class="why-icon">💳</div>
            <h3>Secure Payment</h3>
            <p>UPI, COD &amp; cards accepted</p>
          </div>
        </div>

        <!-- Discover Section -->
        <div class="home-section">
          <div class="home-section-header">
            <div>
              <h2>Curated Men's Wardrobe</h2>
              <p>Handpicked styles for work, weekends and beyond</p>
            </div>
            <div class="section-tabs">
              <span class="tab-item" :class="{active: discoverActive==='SHIRTS'}" @click="discoverActive='SHIRTS'">SHIRTS</span>
              <span class="tab-item" :class="{active: discoverActive==='BLAZERS'}" @click="discoverActive='BLAZERS'">BLAZERS</span>
              <span class="tab-item" :class="{active: discoverActive==='SUITS'}" @click="discoverActive='SUITS'">SUITS</span>
              <span class="tab-item" :class="{active: discoverActive==='TSHIRTS'}" @click="discoverActive='TSHIRTS'">TSHIRTS</span>
            </div>
          </div>
          <ProductGrid :list="discoverProducts" :isMore="false"></ProductGrid>
          <router-link class="section-cta" to="/goods">See More</router-link>
        </div>

        <!-- Full Width Promo Banner -->
        <div class="promo-full-banner">
          <div class="promo-content">
            <span class="promo-tag">Limited Time Offer</span>
            <h2>WINTER WARDROBE 2026</h2>
            <p>Up to 40% Off on Shirts, Suits &amp; Blazers</p>
            <router-link class="promo-btn" to="/goods">Shop Now</router-link>
          </div>
          <div class="promo-image">
            <img src="https://india-shop.oss-ap-southeast-1.aliyuncs.com/shop5/35848059/img_00.jpg" alt="Selected Textured Blazer" />
          </div>
        </div>

        <!-- Split Banners -->
        <div class="split-banners-grid">
          <div class="split-banner">
            <div class="split-content">
              <div class="split-title">Casual Hoodies &amp; Sweatshirts</div>
              <div class="split-desc">
                Soft, versatile hoodies and sweatshirts for relaxed weekends — clean cuts, premium cotton, all-day comfort.
              </div>
              <router-link class="section-cta" to="/goods">Explore Now</router-link>
            </div>
            <div class="split-image">
               <img src="https://india-shop.oss-ap-southeast-1.aliyuncs.com/shop5/38224965/img_00.jpg" alt="H&M Relaxed Fit Hoodie" />
            </div>
          </div>
          <div class="split-banner">
            <div class="split-content">
              <div class="split-title">Polo &amp; Casual T-Shirts</div>
              <div class="split-desc">
                Breathable cotton polos and printed tees — easy staples that pair effortlessly with denim, chinos or shorts.
              </div>
              <router-link class="section-cta" to="/goods">Explore Now</router-link>
            </div>
            <div class="split-image">
               <img src="https://india-shop.oss-ap-southeast-1.aliyuncs.com/shop5/38860309/img_00.jpg" alt="Striped Polo T-shirt" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import * as productsAPI from '@/api/products/'
import * as categoryAPI from '@/api/categories/'
import ProductGrid from '@/components/ProductGrid'

export default {
  components: { ProductGrid },
  data() {
    return {
      carousels: [], // 轮播图数据（后端接口，已忽略：Hero 由下方精选男装图池提供）
      // 男装分类商品列表（Discover 区，对应 sql/男装.sql 分类 ID）
      shirtsList: [],      // 32 casual-shirts + 33 formal-shirts
      blazersList: [],     // 36 blazers
      suitsList: [],       // 37 suits
      tshirtsList: [],     // 31 men-tshirts
      discoverActive: 'SHIRTS', // Discover section active tab
      shirtsProdList: [],
      blazersProdList: [],
      suitsProdList: [],
      tshirtsProdList: [],
      // Hero 轮播：精选男装图池（OSS shop5 路径，来自 sql/男装.sql img_path）
      heroImages: [
        'https://india-shop.oss-ap-southeast-1.aliyuncs.com/shop5/40054267/img_00.jpg', // H&M Double-breasted blazer
        'https://india-shop.oss-ap-southeast-1.aliyuncs.com/shop5/39842659/img_00.jpg', // Blackberrys Three-Piece Suits
        'https://india-shop.oss-ap-southeast-1.aliyuncs.com/shop5/832437/img_00.jpg',   // INVICTUS Formal Shirt
        'https://india-shop.oss-ap-southeast-1.aliyuncs.com/shop5/40408676/img_00.jpg', // VASTRADO Pinstripes Casual Shirt
        'https://india-shop.oss-ap-southeast-1.aliyuncs.com/shop5/36161299/img_00.jpg'  // Moda Rapido Denim Jacket
      ],
      heroIndex: 0,
      heroTimer: null,
      start: 0,
      limit: 7,
      homeCategories: [],
      activeCategoryId: 0,
      homeProducts: [],
      homeStart: 0,
      homeLimit: 8
    }
  },
  computed: {
    currentHeroImage() {
      // 直接使用精选男装图池，忽略后端 carousels
      return this.heroImages[this.heroIndex] || this.heroImages[0]
    },
    discoverProducts() {
      if (this.discoverActive === 'SHIRTS') return this.shirtsProdList
      if (this.discoverActive === 'BLAZERS') return this.blazersProdList
      if (this.discoverActive === 'SUITS') return this.suitsProdList
      return this.tshirtsProdList
    }
  },
  activated() {
    // 获取首页数据
    this.load()
    this.startHeroRotation()
  },
  deactivated() {
    this.stopHeroRotation()
  },
  beforeDestroy() {
    this.stopHeroRotation()
  },
  methods: {
    // Hero 轮播控制
    setHeroIndex(idx) {
      this.heroIndex = idx
    },
    startHeroRotation() {
      this.stopHeroRotation()
      if (!this.heroImages || this.heroImages.length < 2) return
      this.heroTimer = setInterval(() => {
        this.heroIndex = (this.heroIndex + 1) % this.heroImages.length
      }, 5000)
    },
    stopHeroRotation() {
      if (this.heroTimer) {
        clearInterval(this.heroTimer)
        this.heroTimer = null
      }
    },
    load() {
      // 不再请求后端 carousels 接口。Hero 轮播由精选男装图池提供。
      // 首页类目：取导航“Shop Now”同源分类
      categoryAPI
        .listCategories()
        .then(res => {
          if (res.status === 200) {
            const list = Array.isArray(res.data) ? res.data : []
            this.homeCategories = [{ category_id: 0, category_name: 'All' }, ...list]
            this.activeCategoryId = 0
            this.fetchHomeProducts(0)

            // Discover section: men's categories
            this.findDiscoverCategories(list)
          } else {
            this.notifyError('Failed to obtain classification', res.msg)
          }
        })
        .catch(err => {
          this.notifyError('Failed to obtain classification', err)
        })
      // Discover section: men's category product lists
      this.getProduct(32, 'shirtsProdList')     // Casual Shirts
      this.getProduct(33, 'shirtsProdList')     // Formal Shirts
      this.getProduct(36, 'blazersProdList')    // Blazers
      this.getProduct(37, 'suitsProdList')      // Suits
      this.getProduct(31, 'tshirtsProdList')    // Men T-Shirts
    },
    // Find men's categories for the Discover section
    findDiscoverCategories(list) {
      const shirtsCat = list.find(c => (c.category_name || '').toLowerCase() === 'casual-shirts')
      if (shirtsCat) this.getProduct(shirtsCat.category_id, 'shirtsProdList')

      const blazersCat = list.find(c => (c.category_name || '').toLowerCase() === 'blazers')
      if (blazersCat) this.getProduct(blazersCat.category_id, 'blazersProdList')

      const suitsCat = list.find(c => (c.category_name || '').toLowerCase() === 'suits')
      if (suitsCat) this.getProduct(suitsCat.category_id, 'suitsProdList')

      const tshirtsCat = list.find(c => (c.category_name || '').toLowerCase() === 'men-tshirts')
      if (tshirtsCat) this.getProduct(tshirtsCat.category_id, 'tshirtsProdList')
    },
    selectCategory(id) {
      if (this.activeCategoryId === id) return
      this.activeCategoryId = id
      this.homeStart = 0
      this.fetchHomeProducts(id)
    },
    fetchHomeProducts(categoryId) {
      productsAPI
        .listProducts(categoryId, this.homeStart, this.homeLimit)
        .then(res => {
          if (res.status === 200) {
            this.homeProducts = this.shuffle(Array.isArray(res.data.items) ? res.data.items : [])
          } else {
            this.notifyError('Failed', res.msg)
          }
        })
        .catch(err => {
          this.notifyError('Failed', err)
        })
    },
    // 获取各类商品数据方法封装
    getProduct(categoryID, val) {
      productsAPI
        .listProducts(categoryID, this.start, this.limit)
        .then(res => {
          if (res.status === 200) {
            this[val] = this.shuffle(res.data.items || [])
          } else {
            this.notifyError('Failed', res.msg)
          }
        })
        .catch(err => {
          this.notifyError('Failed', err)
        })
    },
    // Fisher-Yates shuffle
    shuffle(array) {
      const arr = [...array]
      for (let i = arr.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1))
        ;[arr[i], arr[j]] = [arr[j], arr[i]]
      }
      return arr
    }
  },
  beforeRouteEnter(to, from, next) {
    // 添加背景色
    document
      .querySelector('body')
      .setAttribute('style', 'background-color:#F5F2EB')
    next()
  },
  beforeRouteLeave(to, from, next) {
    // 去除背景色
    document
      .querySelector('body')
      .setAttribute('style', 'background-color:#F5F2EB')
    next()
  }
}
</script>
<style scoped>
@import '../assets/css/index.css';
</style>
